import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import FoodItemList from "./FoodItemList";
// import { CartProvider, useCart } from "react-use-cart";
import Cookies from 'js-cookie';

export default function FoodItemsSmall(props) {
  const myLang = Cookies.get('i18next');
 
  const foods = props.foods;
//  console.log(props.foods);

  return (
    <>
   
     <div>
      { props.categories ? props.categories.map( (cat,index) => { 

     return(
      <>
     {/* { console.log(props.foods)}
     { console.log(cat)} */}
      <Card.Title className="heading-color p-3 scrollspy-example" data-spy="scroll"
       data-target="#navbar-example2" data-offset="0" id={`${cat.catnameeng}`} data-aos="fade-down">  {(myLang==='fr') ? `${cat.catnamearb}` : `${cat.catnameeng}`}</Card.Title> 
      {/* <FoodItemList  food={food}/> */}
      {props.foods.filter(food => food.cat_id === parseInt(cat.id)).map(food_items => (
        
       <div>
       {/* { console.log('hello',food_items)} */}
          {/* {filteredPerson.name} */}
         { food_items.subcategory ? food_items.subcategory.map((items) =>{
          return(
            <>
               <FoodItemList useCart={props.useCart} food={items}/>
            </>
          );
         }) : ""
        }
         
       </div>
      ))}

      </>
      )

     
      
      }) :"" 

      }
     </div>
    </>
  );
}
